'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _moduleData = require('redux/modules/moduleData');

var moduleActions = _interopRequireWildcard(_moduleData);

var _modules = require('redux/modules/modules');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// for evening meal answers
var YES = 'Yes';
var SOMETIMES = 'Sometimes';
var NO = 'No';

// for where child eats answers
var DINNER_TABLE = 'Dinner table';
var KITCHEN_BENCH = 'Kitchen bench';
var COFFEE_TABLE = 'Coffee table';
var SOFA_COUCH = 'Sofa/couch';
var OTHER = 'Other';

// for would your child often eat dinner with the TV on
var YES_SOME_OR_MOST_MEALS = 'Yes/some or most meals';
var YES_BUT_CANT_SEE = 'Yes, but children can\'t see it/have back to it';
var NO_NEVER_RARELY = 'No/never/rarely';

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module2App4 = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    allModule: state.moduleData.data.module2,
    app: state.moduleData.data.module2.app4
  };
}, (0, _extends3.default)({}, moduleActions, { changeItem: _modules.changeItem })), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module2App4, _Component);

  function Module2App4() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module2App4);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module2App4.__proto__ || (0, _getPrototypeOf2.default)(Module2App4)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      moduleId: 2,
      appId: 4,
      title: 'Home food environment',
      isCompleted: _this.props.app.isCompleted || false,
      eatTogetherAsFamily: _this.props.app.eatTogetherAsFamily || '', // do you eat most evening meals together as a family
      whereChildEatMeal: _this.props.app.whereChildEatMeal || '', // where does your child usually eat his/her evening meal
      howOftenChildAtTable: _this.props.app.howOftenChildAtTable || '', // how often would your child eat dinner sitting at table or bench?
      eatWithTVOn: _this.props.app.eatWithTVOn || '', // would your child often eat dinner with the TV on?
      isTVDistracting: _this.props.app.isTVDistracting || '', // do you find that happening when you're watching tv while eating?
      wouldLikePlanWithoutTV: _this.props.app.wouldLikePlanWithoutTV || '' // would you like to plan a family meal without the tv on?
    }, _this.handleComplete = function () {
      var obj = _this.state;
      var numAppCompleted = _this.props.allModule.numAppCompleted;

      // if its not completed, we increase numAppCompleted
      if (!obj.isCompleted) {
        numAppCompleted++;
      }

      obj.isCompleted = true;
      _this.setState(obj);

      // update the actual app
      _this.props.updateModuleApp(_this.props.user.userId, _this.state.moduleId, _this.state.appId, _this.state);

      // update the overarching module's details
      _this.props.updateModule(_this.props.user.userId, _this.state.moduleId, {
        'numAppCompleted': numAppCompleted,
        'numAppTotal': _this.props.allModule.numAppTotal });

      _this.props.changeItem(_this.state.moduleId, 0, _this.state.appId + 1);
    }, _this.handleeatTogetherAsFamily = function (event) {
      var obj = _this.state;
      obj.eatTogetherAsFamily = event.target.value;
      obj.whereChildEatMeal = '';
      obj.howOftenChildAtTable = '';
      obj.eatWithTVOn = '';
      obj.isTVDistracting = '';
      obj.wouldLikePlanWithoutTV = '';
      _this.setState(obj);
    }, _this.handlewhereChildEatMeal = function (event) {
      var obj = _this.state;
      obj.whereChildEatMeal = event.target.value;
      obj.howOftenChildAtTable = '';
      obj.eatWithTVOn = '';
      obj.isTVDistracting = '';
      obj.wouldLikePlanWithoutTV = '';
      _this.setState(obj);
    }, _this.handlehowOftenChildAtTable = function (event) {
      var obj = _this.state;
      obj.howOftenChildAtTable = event.target.value;
      obj.eatWithTVOn = '';
      obj.isTVDistracting = '';
      obj.wouldLikePlanWithoutTV = '';
      _this.setState(obj);
    }, _this.handleeatWithTVOn = function (event) {
      var obj = _this.state;
      obj.eatWithTVOn = event.target.value;
      obj.isTVDistracting = '';
      obj.wouldLikePlanWithoutTV = '';
      _this.setState(obj);
    }, _this.handleisTVDistracting = function (event) {
      var obj = _this.state;
      obj.isTVDistracting = event.target.value;
      obj.wouldLikePlanWithoutTV = '';
      _this.setState(obj);
    }, _this.handlewouldLikePlanWithoutTV = function (event) {
      var obj = _this.state;
      obj.wouldLikePlanWithoutTV = event.target.value;
      _this.setState(obj);
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * Handle when user finishes this module
   */


  /*
   * General function used to change state of object
   */


  (0, _createClass3.default)(Module2App4, [{
    key: 'renderPositiveTVResponse',


    /*
     * Renders the positive response associated with the TV question
     */
    value: function renderPositiveTVResponse() {
      // const style = require('../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'It\'s OK that children eat dinner in front of the TV occasionally. However, TV can distract us from eating and how hungry we feel, so sometimes we eat more than we need, or sometimes just pick at foods.'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Do you find that happening when you\'re watching TV while eating? Eg. Not being as aware of the food?'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              'Or eating until you feel really stuffed?'
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handleisTVDistracting.bind(this) },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'isTVDistracting', value: 'No' },
              'No'
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'isTVDistracting', value: 'Yes' },
              'Yes'
            )
          )
        ),
        this.state.isTVDistracting === 'Yes' && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'A good place to state is by cutting down how often you have dinners with the TV on.'
              )
            ),
            _react2.default.createElement(
              'li',
              null,
              _react2.default.createElement(
                'span',
                null,
                'As an activity for this week, would you like to plan a family meal without the TV on?'
              )
            )
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handlewouldLikePlanWithoutTV.bind(this) },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'wouldLikePlanWithoutTV', value: 'No', inline: true },
              'No'
            ),
            _react2.default.createElement('br', null),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'wouldLikePlanWithoutTV', value: 'Yes', inline: true },
              'Yes'
            )
          )
        ),
        this.state.wouldLikePlanWithoutTV === 'No' && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'That\'s OK, if you\'d like to try this in the future, remember it\'s easier to make small changes over time than one big change.'
          )
        ),
        this.state.wouldLikePlanWithoutTV === 'Yes' && _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'p',
            null,
            'Can you think of a night this week where this will be possible?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Great. On that night, you\'ll sit down and have a family meal, with no television. The more meals you have without the television on, the better!'
          )
        )
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 2'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'p',
            null,
            'It is important to create a routine for the whole family when it comes to meals and snacks. Sometimes this can be difficult depending on each family\'s circumstances.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Example: shift work, elderly parents, child with high needs. Try to make the most of the times that you can have together. Having regular mealtime and snacks is a useful strategies for many families.'
          ),
          _react2.default.createElement(
            'h5',
            null,
            'Do you eat most evening meals together as a family?'
          ),
          _react2.default.createElement(
            ReactBootstrap.FormGroup,
            { onChange: this.handleeatTogetherAsFamily.bind(this) },
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'eveningmeals', value: 'Yes', checked: this.state.eatTogetherAsFamily === YES },
              'Eat the majority of meals together'
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'eveningmeals', value: 'Sometimes', checked: this.state.eatTogetherAsFamily === SOMETIMES },
              'Sometimes'
            ),
            _react2.default.createElement(
              ReactBootstrap.Radio,
              { name: 'eveningmeals', value: 'No', checked: this.state.eatTogetherAsFamily === NO },
              'No/Rarely'
            )
          ),
          this.state.eatTogetherAsFamily === YES && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'This isn\'t always easy to do, so well done!'
            )
          ),
          this.state.eatTogetherAsFamily === SOMETIMES && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'This isn\'t always easy to do, so well done!'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'if you can\'t increase the number of times that you have family meals, then it\'s great if you can make the most of the mealtimes you do spend together'
                )
              )
            )
          ),
          this.state.eatTogetherAsFamily === NO && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It can be difficult to get the family together for the nightly meal'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It\'s also important to try as often as you can'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'If you can\'t increase the number of times that you have family meals, then it\'s great if you can make the most of the mealtimes that you do spend together'
                )
              )
            )
          ),
          this.state.eatTogetherAsFamily && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'Where does your child usually eat his/her evening meal?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handlewhereChildEatMeal.bind(this) },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'whereChildEatMeal', value: DINNER_TABLE, checked: this.state.whereChildEatMeal === DINNER_TABLE },
                DINNER_TABLE
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'whereChildEatMeal', value: KITCHEN_BENCH, checked: this.state.whereChildEatMeal === KITCHEN_BENCH },
                KITCHEN_BENCH
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'whereChildEatMeal', value: COFFEE_TABLE, checked: this.state.whereChildEatMeal === COFFEE_TABLE },
                COFFEE_TABLE
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'whereChildEatMeal', value: SOFA_COUCH, checked: this.state.whereChildEatMeal === SOFA_COUCH },
                SOFA_COUCH
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'whereChildEatMeal', value: OTHER, checked: this.state.whereChildEatMeal === OTHER },
                OTHER
              )
            )
          ),
          (this.state.whereChildEatMeal === DINNER_TABLE || this.state.whereChildEatMeal === KITCHEN_BENCH) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s really good! \'Eating HELPS\' emphasises that location is very important. This sounds like what you\'re doing!'
            ),
            _react2.default.createElement(
              'h5',
              null,
              'And how often would your child eat dinner sitting at the table or bench?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handlehowOftenChildAtTable.bind(this) },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'howOftenChildAtTable', value: '4 - 7 days per week', checked: this.state.howOftenChildAtTable === '4 - 7 days per week' },
                '4 - 7 days per week'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'howOftenChildAtTable', value: '2 - 3 days per week', checked: this.state.howOftenChildAtTable === '2 - 3 days per week' },
                '2 - 3 days per week'
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'howOftenChildAtTable', value: '1 day per week', checked: this.state.howOftenChildAtTable === '1 day per week' },
                '1 day per week'
              )
            )
          ),
          this.state.howOftenChildAtTable === '4 - 7 days per week' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s fantastic!'
            )
          ),
          this.state.howOftenChildAtTable === '2 - 3 days per week' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s good.'
            )
          ),
          this.state.howOftenChildAtTable === '1 day per week' && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'p',
              null,
              'That\'s ok...'
            )
          ),
          (this.state.whereChildEatMeal === COFFEE_TABLE || this.state.whereChildEatMeal === SOFA_COUCH || this.state.whereChildEatMeal === OTHER) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'Remember that L stands for \'Location\' in the \'Eating HELPS\', suggesting that you encourage your child to eat in places like the kitchen or dining room'
                )
              ),
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'We know this isn\'t always possible, but it\'s a really good habit to get into'
                )
              )
            )
          ),
          (this.state.whereChildEatMeal === COFFEE_TABLE || this.state.whereChildEatMeal === SOFA_COUCH || this.state.whereChildEatMeal === OTHER || this.state.howOftenChildAtTable) && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h5',
              null,
              'Would your child often eat dinner with the television on?'
            ),
            _react2.default.createElement(
              ReactBootstrap.FormGroup,
              { onChange: this.handleeatWithTVOn.bind(this) },
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'television', value: YES_SOME_OR_MOST_MEALS, checked: this.state.eatWithTVOn === YES_SOME_OR_MOST_MEALS },
                YES_SOME_OR_MOST_MEALS
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'television', value: YES_BUT_CANT_SEE, checked: this.state.eatWithTVOn === YES_BUT_CANT_SEE },
                YES_BUT_CANT_SEE
              ),
              _react2.default.createElement(
                ReactBootstrap.Radio,
                { name: 'television', value: NO_NEVER_RARELY, checked: this.state.eatWithTVOn === NO_NEVER_RARELY },
                NO_NEVER_RARELY
              )
            )
          ),
          this.state.eatWithTVOn === YES_SOME_OR_MOST_MEALS && _react2.default.createElement(
            'div',
            null,
            this.renderPositiveTVResponse
          ),
          this.state.eatWithTVOn === YES_BUT_CANT_SEE && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'It\'s great that your children can\'t see the TV while they eat because when distracted we often eat too much or too little. Other parents find that without the television, they are unable to make the most of their time together at meals.'
                )
              )
            ),
            this.renderPositiveTVResponse
          ),
          this.state.eatWithTVOn === NO_NEVER_RARELY && _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'ul',
              null,
              _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                  'span',
                  null,
                  'That\'s fantastic! It\'s great that you can just focus on the meal and the company'
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_components.FinishTaskButton, { onChange: this.handleComplete })
          )
        )
      );
    }
  }]);
  return Module2App4;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object,
  allModule: _propTypes2.default.object,
  app: _propTypes2.default.object,
  updateModule: _propTypes2.default.func,
  updateModuleApp: _propTypes2.default.func,
  changeItem: _propTypes2.default.func
}, _temp2)) || _class);
exports.default = Module2App4;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/2/App/App4.js
// module id = 1184
// module chunks = 0